/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { EntityOrigin } from './EntityOrigin';
import {
    EntityOriginFromJSON,
    EntityOriginFromJSONTyped,
    EntityOriginToJSON,
} from './EntityOrigin';
import type { EnumerationValueDto } from './EnumerationValueDto';
import {
    EnumerationValueDtoFromJSON,
    EnumerationValueDtoFromJSONTyped,
    EnumerationValueDtoToJSON,
} from './EnumerationValueDto';
import type { NumericValueDto } from './NumericValueDto';
import {
    NumericValueDtoFromJSON,
    NumericValueDtoFromJSONTyped,
    NumericValueDtoToJSON,
} from './NumericValueDto';

/**
 * 
 * @export
 * @interface BeamShapingGroupRectangularDto
 */
export interface BeamShapingGroupRectangularDto {
    /**
     * 
     * @type {string}
     * @memberof BeamShapingGroupRectangularDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof BeamShapingGroupRectangularDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BeamShapingGroupRectangularDto
     */
    groupName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BeamShapingGroupRectangularDto
     */
    groupHash?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BeamShapingGroupRectangularDto
     */
    groupId?: string;
    /**
     * 
     * @type {EntityOrigin}
     * @memberof BeamShapingGroupRectangularDto
     */
    origin?: EntityOrigin;
    /**
     * 
     * @type {EnumerationValueDto}
     * @memberof BeamShapingGroupRectangularDto
     */
    radiationFieldShape?: EnumerationValueDto;
    /**
     * 
     * @type {EnumerationValueDto}
     * @memberof BeamShapingGroupRectangularDto
     */
    radiationFieldSymmetry?: EnumerationValueDto;
    /**
     * 
     * @type {NumericValueDto}
     * @memberof BeamShapingGroupRectangularDto
     */
    radiationFieldSizeX?: NumericValueDto;
    /**
     * 
     * @type {NumericValueDto}
     * @memberof BeamShapingGroupRectangularDto
     */
    radiationFieldSizeY?: NumericValueDto;
    /**
     * 
     * @type {NumericValueDto}
     * @memberof BeamShapingGroupRectangularDto
     */
    radiationFieldEdgeX1?: NumericValueDto;
    /**
     * 
     * @type {NumericValueDto}
     * @memberof BeamShapingGroupRectangularDto
     */
    radiationFieldEdgeX2?: NumericValueDto;
    /**
     * 
     * @type {NumericValueDto}
     * @memberof BeamShapingGroupRectangularDto
     */
    radiationFieldEdgeY1?: NumericValueDto;
    /**
     * 
     * @type {NumericValueDto}
     * @memberof BeamShapingGroupRectangularDto
     */
    radiationFieldEdgeY2?: NumericValueDto;
    /**
     * 
     * @type {string}
     * @memberof BeamShapingGroupRectangularDto
     */
    $type?: BeamShapingGroupRectangularDtoTypeEnum;
}


/**
 * @export
 */
export const BeamShapingGroupRectangularDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoSystemSetupParametersBeamShapingGroupRectangularDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.SystemSetupParameters.BeamShapingGroupRectangularDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type BeamShapingGroupRectangularDtoTypeEnum = typeof BeamShapingGroupRectangularDtoTypeEnum[keyof typeof BeamShapingGroupRectangularDtoTypeEnum];



/**
 * Check if a given object implements the BeamShapingGroupRectangularDto interface.
 */
export function instanceOfBeamShapingGroupRectangularDto(value?: unknown): value is BeamShapingGroupRectangularDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(BeamShapingGroupRectangularDtoTypeEnum)[0];
}

export function BeamShapingGroupRectangularDtoFromJSON(json: any): BeamShapingGroupRectangularDto {
    return BeamShapingGroupRectangularDtoFromJSONTyped(json, false);
}

export function BeamShapingGroupRectangularDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BeamShapingGroupRectangularDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'groupName': json['groupName'] == null ? undefined : json['groupName'],
        'groupHash': json['groupHash'] == null ? undefined : json['groupHash'],
        'groupId': json['groupId'] == null ? undefined : json['groupId'],
        'origin': json['origin'] == null ? undefined : EntityOriginFromJSON(json['origin']),
        'radiationFieldShape': json['radiationFieldShape'] == null ? undefined : EnumerationValueDtoFromJSON(json['radiationFieldShape']),
        'radiationFieldSymmetry': json['radiationFieldSymmetry'] == null ? undefined : EnumerationValueDtoFromJSON(json['radiationFieldSymmetry']),
        'radiationFieldSizeX': json['radiationFieldSizeX'] == null ? undefined : NumericValueDtoFromJSON(json['radiationFieldSizeX']),
        'radiationFieldSizeY': json['radiationFieldSizeY'] == null ? undefined : NumericValueDtoFromJSON(json['radiationFieldSizeY']),
        'radiationFieldEdgeX1': json['radiationFieldEdgeX1'] == null ? undefined : NumericValueDtoFromJSON(json['radiationFieldEdgeX1']),
        'radiationFieldEdgeX2': json['radiationFieldEdgeX2'] == null ? undefined : NumericValueDtoFromJSON(json['radiationFieldEdgeX2']),
        'radiationFieldEdgeY1': json['radiationFieldEdgeY1'] == null ? undefined : NumericValueDtoFromJSON(json['radiationFieldEdgeY1']),
        'radiationFieldEdgeY2': json['radiationFieldEdgeY2'] == null ? undefined : NumericValueDtoFromJSON(json['radiationFieldEdgeY2']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function BeamShapingGroupRectangularDtoToJSON(value?: BeamShapingGroupRectangularDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'name': value['name'],
        'groupName': value['groupName'],
        'groupHash': value['groupHash'],
        'groupId': value['groupId'],
        'origin': EntityOriginToJSON(value['origin']),
        'radiationFieldShape': EnumerationValueDtoToJSON(value['radiationFieldShape']),
        'radiationFieldSymmetry': EnumerationValueDtoToJSON(value['radiationFieldSymmetry']),
        'radiationFieldSizeX': NumericValueDtoToJSON(value['radiationFieldSizeX']),
        'radiationFieldSizeY': NumericValueDtoToJSON(value['radiationFieldSizeY']),
        'radiationFieldEdgeX1': NumericValueDtoToJSON(value['radiationFieldEdgeX1']),
        'radiationFieldEdgeX2': NumericValueDtoToJSON(value['radiationFieldEdgeX2']),
        'radiationFieldEdgeY1': NumericValueDtoToJSON(value['radiationFieldEdgeY1']),
        'radiationFieldEdgeY2': NumericValueDtoToJSON(value['radiationFieldEdgeY2']),
        '$type': value['$type'],
    });
}

